import { Galleria } from 'primereact/galleria';
import { useEffect, useState, useRef } from "react"
import Spinner from './Spinner';

export default function GalleriaRow(props) {
    const [activeIndex, setActiveIndex] = useState(0);
    const galleria = useRef(null);
    const [imagesConst, setImagesConst] = useState(null)
    const [loading, setLoading] = useState(true)

    const itemTemplate = (item) => {
        return <img src={item} alt={item.alt} style={{ width: '100%', display: 'block', maxHeight: '80%' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item} alt={item.alt} className="img-thumbnail" style={{ display: 'block' }} />;
    }

    useEffect(() => {
        setLoading(true)

        // Simply use the props.item array directly
        setImagesConst([...props.item])
        setLoading(false)
    }, [props.item, props.id, props.smId])

    if(loading){
        return <><Spinner/></>
    }
    return (
        <>
            <Galleria ref={galleria}
                value={imagesConst}
                numVisible={7}
                style={{ maxWidth: '80%' }}
                activeIndex={activeIndex}
                onItemChange={(e) => setActiveIndex(e.index)}
                circular
                fullScreen={true}
                showItemNavigators
                showThumbnails={false}
                item={itemTemplate}
                thumbnail={thumbnailTemplate}
            />

            <div className="grid row">
                {
                    imagesConst && imagesConst.map((image, index) => {
                        let imgEl = <img className="m-2" src={image} alt={image} style={{ cursor: 'pointer', width: "100%", borderRadius: "2%", height: '250px', objectFit: 'cover' }} onClick={
                            () => { setActiveIndex(index); galleria.current.show() }
                        } />
                        return (
                            <div className="col-3" style={{ width: "33%" }} key={index}>
                                {imgEl}
                            </div>
                        )
                    })
                }
            </div>

        </>
    )
}